// App.js
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { useState, useEffect } from "react";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/Home";
import Entitats from "./pages/Entitats/Entitats";
import Agenda from "./pages/Agenda/Agenda";
import Quisom from "./pages/Qui-som/Qui-som";
import Contact from "./pages/Contact/Contact";
import Botiga from "./pages/Botiga/Botiga";
import NotFound from "./pages/NotFound/NotFound";
import "./global.css";

// Componente principal
function AppContent() {
  const location = useLocation();
  const [showFooter, setShowFooter] = useState(true);

  useEffect(() => {
    // Si estamos en la página de contacto, no mostramos el footer
    setShowFooter(location.pathname !== "/contact");
  }, [location]);

  return (
    <div className="app-container">
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/entitats" element={<Entitats />} />
          <Route path="/qui-som" element={<Quisom />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/botiga" element={<Botiga />} />
          {/* Ruta para página 404 - debe ser la última */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {showFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
